import "./SubHeading.style.scss";
import i18next from "i18next";

const SubHeading = ({ title, description, kind, color, spoonColor }) => {
  const isFa = i18next.language === "fa";

  return (
    <div className={`app_subHeading ${isFa ? "rtl-mode" : "ltr-mode"}`}>
      <div className="app_subHeading-title">
        <div className={`spoon_${spoonColor}`} />
        <h4 className="p__openSans" style={{ color }}>
          {title}
        </h4>
      </div>
      <div className="app_subHeading-description">
        <h1 style={{ color }}>{description}</h1>
        <h1 style={{ color }}>{kind}</h1>
      </div>
    </div>
  );
};

export default SubHeading;
